import React, { useContext, useState,useEffect } from 'react';
import { PageContext } from '../StepProvider';
import { AAMBeaconButton } from 'components/shared/Beacon'
import BeneficiaryContext from '../BeneficiaryContext';
import { cloneDeep, startCase, toLower } from 'lodash';
import Store from 'state/Store';
import '../BeneficiaryDataCardBody.scss';
import { updateBeneficiary } from 'state/beneficiaries/BeneficiaryActions';
import BeaconNotification from 'components/shared/BeaconNotification/BeaconNotification';
import { isTransferOnDeath } from 'services/AccountTypes';
import {
  educationSavingsWarningNotification,
  formatStringIfEducationSavings,
  replaceStringIfEducationSavings,
  renderDesignationHeader,
  informationMissingWarningNotification,
  isMissingBeneficiaryInformation,
  validateBeneficiariesData
} from 'services/BeneficiaryV2';
import { educationSavingsWarning } from 'services/Beneficiary';

export const BeneficiaryManageCard = ({ handleEditClick, name, relationshipName, beneficiary }) => {
  return (
    <React.Fragment>
      <div className="b-grid-item--10-col b-padding-block-start--micro--normal">
        <div className="b-typography-sans-serif--body--100 b-font-weight-light blocked_data">
          {name}
        </div>
        <div className="b-typography-sans-serif--caption--300 blocked_data">
          {startCase(toLower(relationshipName))}
        </div>
      </div>
      <div className="b-grid-item--2-col">
        <AAMBeaconButton
          variant="tertiary"
          onBeaconEventClick={handleEditClick}>
          Edit
        </AAMBeaconButton>
      </div>
      {isMissingBeneficiaryInformation(beneficiary) && informationMissingWarningNotification}
    </React.Fragment>
  );
}
const BeneficiaryManage = () => {
  const {
    selectedGroup,
    setSelectedBeneficiaryId,
    deletedBeneficiary,
    selectedBeneficiaryId,
    beneficiaries,
    isinvalidDelete,
    agreementsForBeneUpdate,
    isEsa,
    setBeneficiaryDataIsComplete
  } = useContext(BeneficiaryContext);
  const { goNext } = useContext(PageContext);
  const { primary, secondary } = beneficiaries;
  const [notificationMessage, setNotificationMessage] = useState(replaceStringIfEducationSavings('Beneficiary deleted', isEsa));
  const mergedBenes = [...primary, ...secondary];
  useEffect(() => {
    setBeneficiaryDataIsComplete(validateBeneficiariesData(mergedBenes));
  }, [mergedBenes]);

  const handleEditClick = (beneficiaryId) => {
    setSelectedBeneficiaryId(beneficiaryId);
    goNext();
  };

  const benenotificationHandler = () => {
    const beneToDelete = cloneDeep(deletedBeneficiary);
    beneToDelete.deleted = false;
    Store.dispatch(updateBeneficiary(selectedBeneficiaryId, beneToDelete));
    setNotificationMessage(replaceStringIfEducationSavings('Beneficiary restored', isEsa));
  };

  const showEducationSavingsWarning = educationSavingsWarning(
    mergedBenes,
    true,
    isEsa
  );
  return (
    <div className="b-grid b-padding-block-end--macro--jumbo beacon-on-lighter">
      <div className="b-grid-item--12-col">
        <div id="modal-header" className="b-typography-serif--headline--200 b-font-weight-bold toolTipGap">
          {formatStringIfEducationSavings("Manage Beneficiaries", isEsa)}
        </div>
        <div className="b-typography-sans-serif--body--200">
          <span className="b-font-weight-light">Assigned to </span>
          <span className="b-font-weight-bold blocked_data ">{selectedGroup}</span>
        </div>
        <div className="b-typography-sans-serif--body--100 b-font-weight-light">
          {formatStringIfEducationSavings("Edit or delete beneficiaries.", isEsa)}
        </div>
      </div>
      <div className="b-grid-item--12-col">
        {showEducationSavingsWarning && educationSavingsWarningNotification}
      </div>
      {deletedBeneficiary && Object.keys(deletedBeneficiary).length > 0 && !isinvalidDelete && (
        <div className="b-grid-item--12-col">
          <BeaconNotification
            title={notificationMessage}
            {...(notificationMessage === replaceStringIfEducationSavings("Beneficiary deleted", isEsa) && {
              ctalabel: "Undo",
              ctaAction: benenotificationHandler,
              showActionZone: true,
              variant: "success",
              dismissable: true,
              type: "inline"
            })}
            {...(notificationMessage === replaceStringIfEducationSavings("Beneficiary restored", isEsa) && {
              variant: "success",
              type: "inline",
              dismissable: true,
            })}
          />
        </div>
      )}
      {isinvalidDelete && <div className="b-grid-item--12-col">
        <BeaconNotification
          title='Primary beneficiary deletion unsuccessful'
          description={agreementsForBeneUpdate &&
            isTransferOnDeath(agreementsForBeneUpdate[0].accountTypeId)
            ? 'A primary beneficiary is required for TOD accounts.'
            : 'A primary beneficiary is required when you have a secondary beneficiary on file.'}
          variant="error"
          dismissable={true}
          type="inline"
        />
      </div>
      }
      {primary.length === 0 && secondary.length === 0 ? (
        <div className="b-grid-item--12-col b-typography-sans-serif--body--100 b-font-weight-light">
          {formatStringIfEducationSavings("You have not named any beneficiaries yet.", isEsa)}
        </div>
      ) : (
        <>
          {primary.length > 0 && (
            <>
              <div className="b-grid-item--12-col b-typography-sans-serif--headline--100 b-font-weight-bold">
                {renderDesignationHeader(isEsa)}
              </div>
              {primary.map((beneficiary) => {
                const { name, relationshipName, _id } = beneficiary;

                return (
                  <BeneficiaryManageCard key={name} beneficiary={beneficiary} name={name} relationshipName={relationshipName} handleEditClick={() => handleEditClick(_id)} />
                );
              })}
            </>
          )}
          {secondary.length > 0 && (
            <>
              <div className="b-grid-item--12-col b-typography-sans-serif--headline--100 b-font-weight-bold">
                Secondary beneficiaries
              </div>
              {secondary.map((beneficiary) => {
                const { name, relationshipName, _id } = beneficiary;

                return (
                  <BeneficiaryManageCard key={name} name={name} beneficiary={beneficiary} relationshipName={relationshipName} handleEditClick={() => handleEditClick(_id)} />
                );
              })}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default BeneficiaryManage;
